import { Component, Input, OnInit } from '@angular/core';
import { SortDescriptor } from '@progress/kendo-data-query';
import { staffViewAll } from 'src/app/shared/helpers/auth-config/staff.config';
import { keyDescOrder } from 'src/app/shared/helpers/helper';
import { SortOrder } from 'src/app/shared/modules/graphql/enums/generic.enums';
import { IApiInvestigationMetricsFilter, IApiInvestigationMetricsOrderBy, IApiInvestigationMetricsState } from 'src/app/shared/modules/graphql/types/types';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';
import { StateService } from 'src/app/shared/services';
import { InvestigationMetricsBasicDataSource, InvestigationMetricsBasicService } from 'src/app/shared/services/reports';

@Component({
  selector: 'app-mobile-investigation-metrics-basic',
  templateUrl: './mobile-investigation-metrics-basic.component.html',
  styleUrls: ['./mobile-investigation-metrics-basic.component.scss']
})
export class MobileInvestigationMetricsBasicComponent implements OnInit {
  public authConfig = {
    staffViewAll,
  };

  @Input() tabIndex: number;
  private _dataSource: InvestigationMetricsBasicDataSource;

  public set dataSource(val) {
    this._dataSource = val;
  }

  public get dataSource() {
    return this._dataSource;
  }

  public get pageOptions() {
    if (!this.dataSource) return null;
    return this.dataSource.listPage;
  }

  public data: any[] = [];
  public sort: SortDescriptor[] = [
    {
      field: IApiInvestigationMetricsOrderBy.ReceivedDate,
      dir: "desc",
    },
  ];
  private userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;


  constructor(
    private investigationMetricsBasicService: InvestigationMetricsBasicService,
    private loaderService: LoaderService,
    private stateService: StateService,
  ) {
    this.dataSource = new InvestigationMetricsBasicDataSource(
      this.investigationMetricsBasicService
    );
    this.loaderService.attachObservable(this.dataSource.loading$);
    this.dataSource.listPage.orderBy = IApiInvestigationMetricsOrderBy.ReceivedDate;
    this.dataSource.listPage.sortOrder = SortOrder.DESC;
  }

  ngOnInit(): void {
    this.load();
  }

  public pageChange(event) {
    this.pageOptions?.paginate(event);
  }

  public sortChange = (e) => {
    this.sort = e;
    if (e && e?.[0]?.dir) {
      this.dataSource.listPage.orderBy = e?.[0]?.field;
      this.dataSource.listPage.sortOrder =
        e?.[0]?.dir === "asc" ? SortOrder.ASC : SortOrder.DESC;
    } else {
      this.dataSource.listPage.orderBy = IApiInvestigationMetricsOrderBy.ReceivedDate;
      this.dataSource.listPage.sortOrder = SortOrder.DESC;
    }
    this.load();
  };

  private load(): void {
    this.dataSource.load().then(() => {
      this.dataSource?.contents$.subscribe((res) => {
        this.data = res.map(item => {
          return {
            ...item,
            data: JSON.parse(item?.data)
          }
        });
      });
    });
  }

  public applyFilter(filters: IApiInvestigationMetricsFilter[]) {
    this.dataSource?.lastFilters?.map(filter => this.dataSource.applyFilter(filter?.type, null));
    filters?.map(filter => this.dataSource.applyFilter(filter?.type, filter?.value));
    this.dataSource.pagingReset();
    this.load();
  }

  public clearFilter(filters: IApiInvestigationMetricsFilter[]) {
    this.dataSource?.lastFilters?.map(filter => this.dataSource.applyFilter(filter?.type, null));
    this.dataSource.pagingReset();
    this.load();
  }

  public getStateName(stateCode: string) {
    return this.stateService.allStates.find(i => i.value === stateCode);
  }

  public keyDescOrder = keyDescOrder;
}
